"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGoBackButtonText = exports.StyledGoBackButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.StyledGoBackButton = styled_components_1.default.div `
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-height: ${helpers_1.SIZE_XXXL};
    padding: 0 ${helpers_1.SPACING_M};
    background-color: ${({ theme }) => theme.colorNavBackground};
    cursor: pointer;
    border-bottom: ${helpers_1.BASE_BORDER_WIDTH} dashed ${({ theme }) => theme.colorBorderNeutral};

    &:hover {
        background-color: ${({ theme }) => theme.colorNavHover};
    }
`;
exports.StyledGoBackButtonText = styled_components_1.default.span `
    margin-left: ${helpers_1.SPACING_M};
    font: ${helpers_1.BASE_FONT};
    color: ${({ theme }) => theme.colorTextNavRest};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
//# sourceMappingURL=GoBackButton.styles.js.map